module.exports = __webpack_public_path__ + "static/images/404-02.8731bc8.png";